import { render, staticRenderFns } from "./StatisticsTableRow.vue?vue&type=template&id=64b9bef8&"
import script from "./StatisticsTableRow.vue?vue&type=script&lang=js&"
export * from "./StatisticsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports